import { render, staticRenderFns } from "./page8.vue?vue&type=template&id=7cfde6e0&"
import script from "./page8.vue?vue&type=script&lang=js&"
export * from "./page8.vue?vue&type=script&lang=js&"
import style0 from "./page8.vue?vue&type=style&index=0&id=7cfde6e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports